(() => {
  const init = () => {
    const root = document.querySelector('.gh-faq');
    if (!root) return;

    const search = root.querySelector('.gh-faq__search');
    const empty = root.querySelector('.gh-faq__empty');
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    if (!search || !items.length) return;

    const filter = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const match = !query || item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
        if (match) {
          visible += 1;
          if (query) item.open = true;
        } else {
          item.open = false;
        }
      });

      groups.forEach((group) => {
        const hasVisible = [...group.querySelectorAll('[data-faq-item]')].some((item) => !item.hidden);
        group.hidden = !hasVisible;
      });

      if (empty) empty.hidden = visible > 0;
    };

    search.addEventListener('input', filter);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
